import { subPaths } from '@bit/bit.utils.fs.sub-paths';
import { TreeNode } from '../../tree-types';

export function traverseFromRoot(treeNode: TreeNode<undefined> | undefined, filePath: string) {
	const segments = subPaths(filePath);

	let currentNode = treeNode;
	let currentPath = segments.shift(); //pop() from start

	while (currentNode !== undefined) {
		if (currentNode.id === filePath) {
			return currentNode; //success!
		}

		const { children } = currentNode;
		currentPath = segments.shift();

		if (!children || !currentPath) return undefined;

		currentNode = children.find(x => !!x && x.id === currentPath);
	}

	return undefined;
}
